import { toastController } from "@ionic/core";

export async function presentToast(message: string, position: 'top' | 'middle' | 'bottom' = 'top', duration = 3000): Promise<HTMLIonToastElement> {
  const toast = await toastController.create({
    //  header: 'Toast header',
    message: message,
    duration: duration,
    position: position || 'top',
  });
  await toast.present();
  return toast;
}